// @ts-nocheck
import { useState, useRef, useEffect, FC } from "react";
import styled from "styled-components";
import colors from "../../../styles/colors";
import { apiDeletePpvGeneraleV2 } from "../../../api/ppvApi";

interface CircleIsActiveProps {
    isActive?: boolean | number;
}

interface SquareIsBigFourProps {
    isBigFour?: boolean | number;
}

const Container = styled.div`
    width: 100%;
    margin-top: 40px;
    padding: 30px;
    background-color: ${colors.bgColorBlack2};
    border: 2px solid gold;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

const Header = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding-bottom: 20px;
    border-bottom: 2px solid rgba(255, 215, 0, 0.3);
`;

const Title = styled.h2`
    font-size: 28px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: gold;
    margin: 0;
    text-align: center;
`;

const PosterContainer = styled.div`
    width: 200px;
    height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 3px solid gold;
    border-radius: 5px;
    overflow: hidden;
    background-color: ${colors.bgColorBlack};
`;

const Poster = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
`;

const InfoContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const InfoSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const InfoLabel = styled.label`
    font-size: 16px;
    font-weight: 600;
    color: gold;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const InfoValue = styled.div`
    font-size: 16px;
    color: white;
    line-height: 1.6;
    padding: 10px;
    background-color: ${colors.bgColorBlack};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StatusContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    padding: 10px;
    background-color: ${colors.bgColorBlack};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StatusItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
`;

const StatusLabel = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
`;

const CircleIsActive = styled.div<CircleIsActiveProps>`
    border: 2px solid ${props => (props.isActive ? 'green' : 'red')};
    border-radius: 50%;
    background-color: ${props => (props.isActive ? 'green' : 'red')};
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 10px ${props => (props.isActive ? 'green' : 'red')};
`;

const SquareIsBigFour = styled.div<SquareIsBigFourProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid ${props => (props.isBigFour ? 'gold' : 'white')};
    width: 30px;
    height: 30px;
    background-color: ${props => (props.isBigFour ? 'gold' : 'transparent')};
    color: ${props => (props.isBigFour ? 'black' : 'white')};
    font-weight: bold;
    box-shadow: ${props => (props.isBigFour ? '0 0 10px gold' : 'none')};
`;

const IdContainer = styled.div`
    width: 100%;
    padding: 10px;
    background-color: ${colors.bgColorBlack};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
`;

const IdLabel = styled.span`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const IdValue = styled.span`
    font-size: 16px;
    color: white;
    font-weight: 600;
    margin-left: 10px;
`;

const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 2px solid rgba(255, 215, 0, 0.3);
    flex-wrap: wrap;
`;

const EditButton = styled.button`
    padding: 12px 24px;
    background-color: ${colors.bgColorBordeaux};
    color: white;
    border: 2px solid gold;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;

    &:hover {
        transform: scale(1.05);
        background-color: ${colors.bgColorRed};
    }

    &:active {
        transform: scale(0.98);
    }
`;

const DeleteButton = styled.button`
    padding: 12px 24px;
    background-color: #dc3545;
    color: white;
    border: 2px solid #dc3545;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out, opacity 0.2s ease-in-out;

    &:hover:not(:disabled) {
        transform: scale(1.05);
        background-color: #c82333;
        border-color: #c82333;
    }

    &:active:not(:disabled) {
        transform: scale(0.98);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const DeleteWarningMessage = styled.div`
    width: 100%;
    padding: 12px 20px;
    background-color: rgba(220, 53, 69, 0.1);
    border: 2px solid #dc3545;
    border-radius: 5px;
    color: #dc3545;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    margin: 15px 0;
`;

const PpvSpecificListContainer = styled.div`
    width: 100%;
    margin-top: 30px;
    padding-top: 30px;
    border-top: 10px solid rgba(255, 215, 0, 0.3);
`;

const PpvSpecificListTitle = styled.h3`
    font-size: 20px;
    font-weight: 600;
    color: gold;
    text-transform: uppercase;
    letter-spacing: 2px;
    text-align: center;
    margin-bottom: 20px;
`;

const PpvSpecificGrid = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    row-gap: 15px;
    column-gap: 15px;
`;

const AddPpvSpecificButton = styled.button`
    padding: 12px 24px;
    background-color: ${colors.bgColorBordeaux};
    color: white;
    border: 2px solid gold;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
    margin: 20px 0;
    display: block;
    margin-left: auto;
    margin-right: auto;

    &:hover {
        transform: scale(1.05);
        background-color: ${colors.bgColorRed};
    }

    &:active {
        transform: scale(0.98);
    }
`;

const PpvSpecificCard = styled.div`
    width: 125px;
    /* flex: 1 1 auto; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: transform 0.3s ease-in-out;

    & img.poster-ppv-specific {
        max-width: 100%;
        width: 100%;
        height: 180px;
        object-fit: cover;
        object-position: top;
        border: 1px solid white;
        border-radius: 5px;
    }

    & p.date-ppv-specific {
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        margin-top: 10px;
        color: white;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    &.selected img.poster-ppv-specific {
        border: 5px solid gold;
    }

    &.selected p.date-ppv-specific {
        color: gold;
    }

    &:hover {
        transform: scale(1.05);
    }
`;

interface PpvSpecific {
    id: number;
    date?: string | number;
    img_path?: string;
    [key: string]: unknown;
}

interface PpvGenerale {
    id: number;
    name: string;
    description?: string;
    is_active?: boolean | number;
    is_big_four?: boolean | number;
    img_path?: string;
    ppvs?: PpvSpecific[];
}

interface Props {
    ppvGenerale: PpvGenerale | null;
    onEditClick?: () => void;
    onDeleteClick?: () => void;
    onPpvSpecificSelect?: (ppvSpecific: PpvSpecific) => void;
    onAddPpvSpecificClick?: () => void;
}

const PpvGeneraleDetail: FC<Props> = ({ ppvGenerale, onEditClick, onDeleteClick, onPpvSpecificSelect, onAddPpvSpecificClick }) => {
    const [isDeleting, setIsDeleting] = useState<boolean>(false);
    const [selectedPpvSpecific, setSelectedPpvSpecific] = useState<PpvSpecific | null>(null);
    const ppvSpecificListRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (selectedPpvSpecific && ppvSpecificListRef.current) {
            setTimeout(() => {
                ppvSpecificListRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        }
    }, [selectedPpvSpecific]);

    const formatDateFromTimestamp = (dateValue: string | number | undefined): string => {
        if (!dateValue) return 'N/A';

        let date: Date;

        if (typeof dateValue === 'number') {
            if (dateValue > 1e12) {
                date = new Date(dateValue);
            } else {
                date = new Date(dateValue * 1000);
            }
        }
        else if (typeof dateValue === 'string') {
            if (/^\d+$/.test(dateValue)) {
                const numValue = parseInt(dateValue);
                if (numValue > 1e12) {
                    date = new Date(numValue);
                } else {
                    date = new Date(numValue * 1000);
                }
            }
            else if (dateValue.includes('-')) {
                date = new Date(dateValue);
            }
            else {
                date = new Date(dateValue);
            }
        }
        else {
            date = new Date(dateValue as string);
        }

        if (isNaN(date.getTime())) {
            console.warn('Data non valida:', dateValue);
            return 'N/A';
        }

        return date.toLocaleDateString('it-IT', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    if (!ppvGenerale) {
        return null;
    }

    const hasAssociatedPpvs = ppvGenerale.ppvs && Array.isArray(ppvGenerale.ppvs) && ppvGenerale.ppvs.length > 0;
    const canDelete = !hasAssociatedPpvs;

    const handlePpvSpecificClick = (ppvSpecific: PpvSpecific) => {
        setSelectedPpvSpecific(ppvSpecific);
        if (onPpvSpecificSelect) {
            onPpvSpecificSelect(ppvSpecific);
        }
    };

    const handleDelete = async () => {
        const confirmDelete = window.confirm(`Sei sicuro di voler eliminare il PPV Generale "${ppvGenerale.name}"?`);
        if (!confirmDelete) return;

        setIsDeleting(true);
        try {
            const response = await apiDeletePpvGeneraleV2(ppvGenerale.id);
            if ((response as { error?: string }).error) {
                console.error('Errore durante l\'eliminazione del PPV:', (response as { error?: string }).error);
                alert('Errore durante l\'eliminazione del PPV');
            } else {
                if (onDeleteClick) {
                    onDeleteClick();
                }
            }
        } catch (error) {
            console.error('Errore durante l\'eliminazione del PPV:', error);
            alert('Errore durante l\'eliminazione del PPV');
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <Container className="ppv-generale-detail-container">
            <Header className="ppv-generale-detail-header">
                <Title className="ppv-generale-detail-title">{ppvGenerale.name}</Title>
                {!canDelete && (
                    <DeleteWarningMessage className="ppv-generale-detail-delete-warning-message">
                        Il ppv si può eliminare solamente se non ci sono altri ppv specifici
                    </DeleteWarningMessage>
                )}
                <ButtonContainer className="ppv-generale-detail-button-container">
                    <EditButton
                        onClick={onEditClick}
                        className="ppv-generale-detail-edit-button"
                    >
                        Modifica Ppv Generale
                    </EditButton>
                    <DeleteButton
                        onClick={handleDelete}
                        disabled={!canDelete || isDeleting}
                        className="ppv-generale-detail-delete-button"
                    >
                        {isDeleting ? 'Eliminazione...' : 'Elimina'}
                    </DeleteButton>
                </ButtonContainer>
                <PosterContainer className="ppv-generale-detail-poster-container">
                    <Poster
                        src={process.env.REACT_APP_STORAGE_URL + ppvGenerale.img_path}
                        alt={ppvGenerale.name + "_poster"}
                        className="ppv-generale-detail-poster"
                    />
                </PosterContainer>
            </Header>

            <InfoContainer className="ppv-generale-detail-info-container">
                <InfoSection className="ppv-generale-detail-info-section">
                    <InfoLabel className="ppv-generale-detail-info-label">Descrizione</InfoLabel>
                    <InfoValue className="ppv-generale-detail-info-value">
                        {ppvGenerale.description || "Nessuna descrizione disponibile"}
                    </InfoValue>
                </InfoSection>

                <InfoSection className="ppv-generale-detail-info-section">
                    <InfoLabel className="ppv-generale-detail-info-label">Stato</InfoLabel>
                    <StatusContainer className="ppv-generale-detail-status-container">
                        <StatusItem className="ppv-generale-detail-status-item">
                            <StatusLabel className="ppv-generale-detail-status-label">Attivo:</StatusLabel>
                            <CircleIsActive
                                isActive={ppvGenerale.is_active}
                                className="ppv-generale-detail-circle-active"
                            />
                            <StatusLabel className="ppv-generale-detail-status-label">
                                {ppvGenerale.is_active ? "Sì" : "No"}
                            </StatusLabel>
                        </StatusItem>
                        <StatusItem className="ppv-generale-detail-status-item">
                            <StatusLabel className="ppv-generale-detail-status-label">Big Four:</StatusLabel>
                            <SquareIsBigFour
                                isBigFour={ppvGenerale.is_big_four}
                                className="ppv-generale-detail-square-big-four"
                            >
                                <span>4</span>
                            </SquareIsBigFour>
                            <StatusLabel className="ppv-generale-detail-status-label">
                                {ppvGenerale.is_big_four ? "Sì" : "No"}
                            </StatusLabel>
                        </StatusItem>
                    </StatusContainer>
                </InfoSection>
            </InfoContainer>

            {/* Lista dei PPVs specifici */}
            <PpvSpecificListContainer ref={ppvSpecificListRef} className="ppv-generale-detail-ppv-specific-list-container">
                <PpvSpecificListTitle className="ppv-generale-detail-ppv-specific-list-title">
                    PPVs Specifici
                </PpvSpecificListTitle>

                {/* Bottone che apre il modale per creare un nuovo PPV Specifico */}
                <AddPpvSpecificButton
                    onClick={onAddPpvSpecificClick}
                    className="ppv-generale-detail-add-ppv-specific-button"
                >
                    Aggiungi Ppv Specifico
                </AddPpvSpecificButton>

                {hasAssociatedPpvs && (
                    <PpvSpecificGrid className="ppv-generale-detail-ppv-specific-grid">
                        {ppvGenerale.ppvs!.map((ppvSpecific: any) => (
                            <PpvSpecificCard
                                key={ppvSpecific.id}
                                className={`ppv-generale-detail-ppv-specific-card ${selectedPpvSpecific && selectedPpvSpecific.id === ppvSpecific.id ? 'selected' : ''}`}
                                onClick={() => handlePpvSpecificClick(ppvSpecific)}
                            >
                                <img
                                    src={process.env.REACT_APP_STORAGE_URL + ppvSpecific.img_path}
                                    alt={ppvSpecific.img_path + "_alt"}
                                    className="poster-ppv-specific"
                                />
                                <p className="date-ppv-specific">
                                    {formatDateFromTimestamp(ppvSpecific.date)}
                                </p>
                            </PpvSpecificCard>
                        ))}
                    </PpvSpecificGrid>
                )}

            </PpvSpecificListContainer>
        </Container>
    );
};

export default PpvGeneraleDetail;
